// olap-client/src/components/chat/ChatHeader.jsx
import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';

const ChatHeader = observer(() => {
  const { chat } = useContext(Context);

  if (!chat.activeChat) return null;

  const getCompanionName = (chatItem) => {
    if (chatItem.type === 'private') {
      if (chatItem.companion) {
        const name = chatItem.companion.name || '';
        const surname = chatItem.companion.surname || '';
        const fullName = `${name} ${surname}`.trim();
        if (fullName) return fullName;
        if (chatItem.companion.email) return chatItem.companion.email;
      }
      
      if (chatItem.ChatMembers) {
        const currentUserId = JSON.parse(localStorage.getItem('user') || '{}').id;
        const otherMember = chatItem.ChatMembers.find(m => m.userId !== currentUserId);
        if (otherMember && otherMember.user) {
          const name = otherMember.user.persons_info?.name || '';
          const surname = otherMember.user.persons_info?.surname || '';
          const fullName = `${name} ${surname}`.trim();
          if (fullName) return fullName;
          if (otherMember.user.email) return otherMember.user.email;
        }
      }
      
      return 'Собеседник';
    }
    return chatItem.name || 'Чат';
  };

  return (
    <div style={{
      padding: '10px 15px',
      borderBottom: '1px solid #e4e4e5',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      background: '#ffffff',
      minHeight: '50px'
    }}>
      {/* Кнопка назад для мобильной версии */}
      {chat.isMobile && (
        <button
          onClick={() => chat.setActiveChatNull()}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            padding: '0 5px',
            color: '#3390ec'
          }}
        >
          ←
        </button>
      )}

      <div style={{ fontWeight: 'bold', flex: 1, fontSize: '16px' }}>
        {getCompanionName(chat.activeChat)}
      </div>

      {chat.typingText && (
        <div style={{ 
            fontSize: '12px', 
            color: '#3390ec', 
            fontStyle: 'italic',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        }}>
            <span>{chat.typingText}</span>
            <span className="typing-dots">
            <style>{`
                @keyframes typingDot {
                0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
                30% { opacity: 1; transform: translateY(-3px); }
                }
                .typing-dots span {
                display: inline-block;
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background: #3390ec;
                margin: 0 1px;
                animation: typingDot 1.4s infinite;
                }
                .typing-dots span:nth-child(2) {
                animation-delay: 0.2s;
                }
                .typing-dots span:nth-child(3) {
                animation-delay: 0.4s;
                }
            `}</style>
            <span>.</span>
            <span>.</span>
            <span>.</span>
            </span>
        </div>
        )}

      {/* Кнопка настроек чата (только для ПК) */}
      {!chat.isMobile && (
        <button
          onClick={() => chat.toggleRightSidebar()}
          style={{
            background: chat.showRightSidebar ? '#f0f0f0' : 'transparent',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            padding: '8px',
            marginRight: '50px',  // Увеличенный отступ справа
            borderRadius: '50%',
            transition: 'all 0.2s',
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          onMouseEnter={(e) => {
            if (!chat.showRightSidebar) {
              e.currentTarget.style.background = '#f4f4f5';
            }
          }}
          onMouseLeave={(e) => {
            if (!chat.showRightSidebar) {
              e.currentTarget.style.background = 'transparent';
            }
          }}
          title={chat.showRightSidebar ? 'Скрыть настройки' : 'Показать настройки'}
        >
          {chat.showRightSidebar ? '✖' : '⚙️'}
        </button>
      )}
    </div>
  );
});

export default ChatHeader;